<template>
    <label class="wrapper flex items-center">
        {{label}}
        <input class="checkbox" type="checkbox" :checked="isChecked" :value="value" @change="updateInput"/>
        <span class="checkmark"></span>
    </label>
</template>

<script>
    export default {
        model: {
            prop: 'modelValue',
            event: 'change'
        },
        props: {
            value: {
                type: String
            },
            modelValue: {
                default: ""
            },
            label: {
                type: String,
                default: '',
            },
            trueValue: { default: true },
            falseValue: { default: false }
        },
        computed: {
            isChecked() {
                if (this.modelValue instanceof Array) {
                    return this.modelValue.includes(this.value)
                }
                // Note that `true-value` and `false-value` are camelCase in the JS
                return this.modelValue === this.trueValue
            }
        },
        methods: {
            updateInput(event) {
                let isChecked = event.target.checked

                if (this.modelValue instanceof Array) {
                    let newValue = [...this.modelValue]

                    if (isChecked) {
                        newValue.push(this.value)
                    } else {
                        newValue.splice(newValue.indexOf(this.value), 1)
                    }

                    this.$emit('change', newValue)
                } else {
                    this.$emit('change', isChecked ? this.trueValue : this.falseValue)
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
  .checkbox {
        filter: hue-rotate(300deg) brightness(1.2);
    }
</style>